export const getBuyersListUrl = "/api/v3/buyer/search";
export const getusersByBuyerIdUrl = "/api/v3/buyer/:buyerId/users";
